module.exports = __webpack_public_path__ + "img/paypal.4b8c3d06.png";